import React from 'react'
import './kovin.css';



function NareshPradhan() {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">National</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/naresh.png" alt="Naresh Pradhan" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Naresh Pradhan</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
                Narresh Pradhan, a highly respected Senior Optometrist 
                and Programme Director at the Eye Care Institute, Sri Lanka. 
                With a strong commitment to advancing optometric education 
                and clinical excellence, Mr. Pradhan has played a pivotal role 
                in training and mentoring the next generation of eye care 
                professionals. His leadership and dedication continue to make 
                a meaningful impact in the field of optometry.
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
            <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default NareshPradhan